import { BugContext } from 'features/feedback/shared/feedback.types';
import { getErrors } from 'features/feedback/collectContext/consoleBuffer';

export function parseBrowser(ua: string): string {
  if (/Edg/.test(ua)) return 'Edge';
  if (/Chrome/.test(ua)) return 'Chrome';
  if (/Firefox/.test(ua)) return 'Firefox';
  if (/Safari/.test(ua)) return 'Safari';
  return 'Браузер';
}

export function parseOs(ua: string): string {
  if (/Mac/.test(ua)) return 'macOS';
  if (/Win/.test(ua)) return 'Windows';
  if (/Android/.test(ua)) return 'Android';
  if (/Linux/.test(ua)) return 'Linux';
  return 'ОС';
}

export function collectContext(): BugContext {
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  return {
    route: typeof location !== 'undefined' ? location.pathname : '',
    version: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'unknown',
    browser: parseBrowser(ua),
    os: parseOs(ua),
    locale: typeof navigator !== 'undefined' ? navigator.language : 'uk-UA',
    viewport:
      typeof window !== 'undefined' ? `${window.innerWidth}×${window.innerHeight}` : '',
    errors: getErrors(),
  };
}
